/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
export async function login(token) {

    try {
        const url = process.env.REACT_APP_API_URL + "auth/login/";
        const requestBody =
            {
                "ACCESS_TOKEN": {
                    "S": token
                }
            }
        const request = {
            method: "POST",
            body: JSON.stringify(requestBody)
        }
        const response = await fetch(url, request);
        const json = await response.json();
        if (json.statusCode !== 200) {
            throw new Error("STATUS: " + json.statusCode);
        }
        return json;
    } catch (error) {
        return {
            statusCode: 500,
            body: {
                message: error.message
            }
        }
    }
}